import { render, staticRenderFns } from "./info-dialog.vue?vue&type=template&id=1790eddf&scoped=true"
import script from "./info-dialog.vue?vue&type=script&lang=js"
export * from "./info-dialog.vue?vue&type=script&lang=js"
import style0 from "./info-dialog.vue?vue&type=style&index=0&id=1790eddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1790eddf",
  null
  
)

export default component.exports